import React from "react"
import CCLogo from "../Imgs/CCLogo.png"
import Label from '@react/react-spectrum/Label'

export default class DownloadTopPanel extends React.Component {
    constructor(props) {
        super(props)
    }
    render() {
        const {title,desc} = this.props
        return (
            <>
                {(1===0) && <h3>{(`${desc}`).toUpperCase()} </h3>}
                <h1>Save your {title}</h1>
                <p>Edit and download your {title} as a JPG or start over by adding a new photo.</p>
            </>
        )
    }
}